<div class="filter-table-section">
  <div class="filter-title-section" *ngIf="classificationMethod !== 'PACKAGE' && tableType=== 'turnover'">
    <div class="title">
      <span *ngIf="classificationMethod === 'PRODUCT_GROUP'">Product Group: {{ productGroup }}</span>
      <span *ngIf="classificationMethod === 'CBF'">
        CBF: {{ cbf }} {{ cbfDesc ? '(' + cbfDesc + ')' : '' }}
      </span>
    </div>
    <div class="key-value-box">
      <div class="key-value-item">
        <div class="key">Target Turnover</div>
        <div class="value">
          {{ salesPortalService.formatThousands(targetAmount) }}<span class="unit">(CNY)</span></div>
      </div>
      <div class="key-value-item">
        <div class="key">Remaining</div>
        <div class="value">{{ salesPortalService.formatThousands(remainingUndivided) }}<span class="unit">(CNY)</span>
        </div>
      </div>
    </div>
  </div>
  <nz-table #table nzBordered [nzData]="tableData" [nzFrontPagination]="false" class="detail-table"
            nzTableLayout="fixed">
    <thead>
    <tr>
      <th nzWidth="132px" class="th"></th>
      <th nzAlign="center" class="th" *ngFor="let data of columns">{{ data.name }}</th>
    </tr>
    </thead>
    <tbody>
    <tr>
      <td class="th">Purchase Amount</td>
      <td *ngFor="let data of table.data" class="td" nzEllipsis nzAlign="center">
        <sales-portal-input-number
          [title]="data.targetAmount"
          [disabled]="!canEdit"
          [(ngModel)]="data.targetAmount"
          [height]="'40px'"
          [maxFractionDigits]="tableType === 'workshop-acquisition'? 0 : 2"
          [minFractionDigits]="tableType === 'workshop-acquisition'? 0 : 2"
        ></sales-portal-input-number>
      </td>
    </tr>
    </tbody>
  </nz-table>
</div>
